/**
 * Created by Administrator on 2019/10/6.
 */
import { request, requestNew } from "../utils/request";
import serviceInterface from "../api/serviceInterface";

/**
 * 登陆用户
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const loginUser = (params) => {
  return requestNew({
    url: serviceInterface.auth.login,
    params: params,
    isShow: "1",
  });
};

/**
 * 注册
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const signUp = (params) => {
  return requestNew({
    url: serviceInterface.auth.signUp,
    params: params,
    isShow: "1",
  });
};

/**
 * 重置密码
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const resetPwd = (params) => {
  return requestNew({
    url: serviceInterface.auth.resetPwd,
    params: params,
    isShow: "1",
  });
};

/**
 * 获取验证码
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const getVerificationCode = (params) => {
  return requestNew({
    url: serviceInterface.auth.getCode,
    params: params,
    isShow: "1",
  });
};

/**
 * 校验图片验证码
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const checkCaptcha = (params) => {
  return requestNew({
    url: serviceInterface.auth.checkCaptcha,
    params: params,
    isShow: "1",
  });
};

/**
 * 校验图片验证码
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const getCaptcha = (params) => {
  return request({
    url: serviceInterface.auth.getCaptcha,
    params: params,
  });
};

/**
 * 获取用户
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const getSessionUser = (params) => {
  return request({
    url: serviceInterface.auth.getSessionUser,
    params: params,
  });
};

/**
 * 通过token获取用户
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const loginAuthKey = (params) => {
  return requestNew({
    url: serviceInterface.auth.loginAuthKey,
    params: params,
    isShow: "1",
  });
};

/**
 * 获取弹窗提示
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const getMessageShow = (params) => {
  return request({
    url: serviceInterface.auth.getMessageShow,
    params: params,
  });
};

/**
 * 邀请好友
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const inviteFriends = () => {
  return request({
    url: serviceInterface.auth.inviteFriends,
  });
};

/**
 * 邀请好友
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const inviteRecords = (params) => {
  return request({
    url: serviceInterface.auth.inviteRecords,
    params: params,
  });
};
/**
 * 绑定手机或邮箱
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const BindAccount = (params) => {
  return request({
    url: serviceInterface.auth.bindAccount,
    params: params,
  });
};

/**
 * 修改密码
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const updatePwd = (params) => {
  return requestNew({
    url: serviceInterface.auth.updatePwd,
    params: params,
    isShow: "1",
  });
};
